import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { GET_ALLOCATION, GET_QUOTE, ASSIGNMENTS, END_CLIENTS, GET_MANAGERS, GET_WORKERS, GET_TEAMS, GET_CURRENCY, GET_PAYRATE } from './endpoints';

@Injectable({
  providedIn: 'root'
})
export class IwgSelectService extends BaseService{

  constructor(http: HttpClient) {
    super(http);
  }
  getAssignments(assignments): Observable<any>{
    const url = ASSIGNMENTS + '?' + this.makeQueryString(assignments);
    return this.getRequest(url, null);
  }
  getQuotes(countriesParams): Observable<any>{
    const url = GET_QUOTE + '?' + this.makeQueryString(countriesParams);
    return this.getRequest(url, null);
  }
  getSingleQuote(id: string): Observable<any>{
    const url = GET_QUOTE + id;
    return this.getRequest(url, null);
  }
  loadItems(): Observable<any>{
    const url = GET_QUOTE ;
    return this.getRequest(url, null);
  }
  getEndclients(): Observable<any>{
    const url = END_CLIENTS + '?limit=0';
    return this.getRequest(url, null);
  }
  getManagers(): Observable<any>{
    const url = GET_MANAGERS + '?limit=0';
    return this.getRequest(url, null);
  }
  getWorkers(): Observable<any>{
    const url = GET_WORKERS + '?limit=0';
    return this.getRequest(url, null);
  }
  getTeams(): Observable<any>{
    const url = GET_TEAMS + '?limit=0';
    return this.getRequest(url, null);
  }
  getCurrency(): Observable<any>{
    const url = GET_CURRENCY + '?limit=0';
    return this.getRequest(url, null);
  }
  getPayrate(compilance: string): Observable<any>{
    const url = GET_PAYRATE + '?limit=0&iscompliance=' + compilance;
    return this.getRequest(url, null);
  }
  
  getAllocation(assignmentId: string): Observable<any>{
    const url = GET_ALLOCATION +  assignmentId;
    return this.getRequest(url, null);
  }
  
  getCharges(params): Observable<any>{
    const url = ASSIGNMENTS + '?' + this.makeQueryString(params);
    return this.getRequest(url, null);
  }
}
